<template>
  <div>
    <section class="text_center" v-if="isCarrier('docomo')">
      <h2 class="header_underline">docomo(スマートフォン)設定方法</h2>
      <div class="text_left">
        <p>【1】spモードメールアプリを起動します。</p>
        <p>【2】「メール設定」を選択します。</p>
        <p>【3】「その他」を選択します。</p>
        <p>【4】「メール全般の設定」を選択します。</p>
        <p>【5】詳細/その他設定（詳細設定/解除）を選択します。</p>
        <p>【6】パスワードを入力します。</p>
        <p>【7】受信/拒否設定（設定）を選択します。</p>
        <p>【8】「次へ」を選択します。</p>
        <p>【9】「ステップ４（受信設定）」を選択します。</p>
        <p>【10】「▽個別に受信したいドメインまたはアドレス」に「@{{ info.mailDomain }}」と入力して「登録」を選択します。</p>
      </div>
    </section>
        <section class="text_center" v-if="isCarrier('au')">
      <h2 class="header_underline">au(スマートフォン)設定方法</h2>
      <div class="text_left">
        <p>【1】画面下の「メール」のアプリを起動します。</p>
        <p>【2】「設定」を選択します。</p>
        <p>【3】「Eメール設定」を選択します。</p>
        <p>【4】「その他の設定」を選択します。</p>
        <p>【5】「パケット通信料が発生します」のメッセージが表示されたら、「OK」ボタンを押します。</p>
        <p>【6】「迷惑フィルター」を設定します。</p>
        <p>【7】「暗証番号」を入力し「送信」ボタンを押します。</p>
        <p>【8】「詳細設定」を選択します。</p>
        <p>【9】「指定受信リスト設定」で「設定する」にチェックを入れ「次へ」ボタンを押します。</p>
        <p>【10】入力欄に「@{{ info.mailDomain }}」と入力して「登録」を選択します。</p>
        <p>【11】内容を確認し「登録」ボタンを押します。</p>
      </div>

      <h2 class="header_underline">au(iPhone)設定方法</h2>
      <div class="text_left">
        <p>【1】「メッセージ」をタップします。</p>
        <p>【2】宛先に「#5000」、本文に「1234」を入力し「送信」をタップします。</p>
        <p>
            【3】受信したSMSに記載されている「メール設定URL」をタップ後、メール設定画面にアクセスします。<br>
            ※メッセージ（SMS）の受信には時間が掛かる場合があります。<br>
            ※メッセージ（SMS）着信から60分以内にアクセスしてください。<br>
            60分以内にアクセスしてください。<br>
            60分を超えてのアクセスはエラーとなります。<br>
            エラーとなった場合には、再度「#5000」宛へメッセージ（SMS）を送信して下さい。
        </p>
        <p>【4】EZwebメール設定画面を下にスクロールし、「Eメールアドレス変更・迷惑メールフィルター・自動転送」をタップします。</p>
        <p>【5】「迷惑メールフィルター」をタップします。</p>
        <p>【6】au電話ご契約時に設定された「暗証番号」入力し、「送信」をタップします。</p>
        <p>【7】「指定受信リスト設定」をタップします。</p>
        <p>【8】「設定する」にチェックをいれ、「次へ」をタップします。</p>
        <p>【9】「@{{ info.mailDomain }}」を入力し、「登録」をタップします。</p>
        <p>【10】キーワードが「@{{ info.mailDomain }}」になっていることを確認して「登録」をタップします。</p>
        <p>【11】「登録が完了しました」の画面が表示されたら指定受信リスト設定完了です。</p>
      </div>
    </section>
    <section class="text_center" v-if="isCarrier('softbank')">
      <h2 class="header_underline">softbank設定方法</h2>
      <div class="text_left">
        <p>【1】携帯電話の「Y!ボタン」を押します。</p>
        <p>【2】画面最下部「設定・申込」を選択します。</p>
        <p>【3】設定・変更「４メール設定」を選択します。</p>
        <p>【4】「１.メール設定（アドレス・迷惑メール等）」を選択します。</p>
        <p>【5】「迷惑メールブロック設定」を選択します。</p>
        <p>【6】「個別設定」にチェックを入れ「次へ」ボタンを押します。</p>
        <p>【7】「５.受信許可・拒否設定」を選択します。 </p>
        <p>【8】「受信許可リスト設定」を選択します。 </p>
        <p>【9】「設定する」にチェックを入れます。 </p>
        <p>【10】アドレス入力欄に「@{{ info.mailDomain }}」と入力し「後」にチェックを入れます。</p>
        <p>【11】画面最下部「設定する」ボタンを押します。 </p>
      </div>

      <h2 class="header_underline">softbank(iPhone)設定方法</h2>
      <div class="text_left">
        <p>【1】ブラウザ（safari）を起動し、画面下ブックマークアイコンを押します。</p>
        <p>【2】「MySoftbank」を選択します。</p>
        <p>【3】「ログインはこちら」を選択します。</p>
        <p>【4】「携帯電話番号」「パスワード」を入力します。</p>
        <p>【5】「メール設定」の「Eメール（i）」を選択します。</p>
        <p>【6】「迷惑メールブロック設定」の「次へ」ボタンを押します。</p>
        <p>【7】「受信許可リスト」の「変更」ボタンを押します。</p>
        <p>【8】「追加」をクリックします。</p>
        <p>【9】「メールアドレスの一部(または全部)」に「@{{ info.mailDomain }}」と入力し、「後方一致」にチェックをいれ、「次へ」をクリックします。</p>
        <p>【10】「登録」をクリックし、設定完了です。</p>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'CarrierDetail',
  data () {
    return {
      info: this.$store.getters.siteInfo || null
    }
  },
  methods: {
    isCarrier (carrier) {
      const paramsCarrier = this.$route.params.carrier || ''
      return paramsCarrier === carrier
    }
  }
}
</script>
